module.exports = __webpack_public_path__ + "static/media/m1_sf_12.8bb50380.png";